import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const createApiKey = gql`
  mutation CreateApiKeyMutation($input: CreateApiKey!) {
    createApiKey(input: $input) {
      authToken
      apiKey {
        ...ApiKey
      }
    }
  }

  ${Fragments.apiKey.apiKey}
`;

export const deleteApiKey = gql`
  mutation DeleteApiKeyMutation($id: UUID!) {
    deleteApiKey(id: $id)
  }
`;
